import {Directive, Injectable} from '@angular/core';
import {AbstractControl, AsyncValidator, AsyncValidatorFn, NG_ASYNC_VALIDATORS, ValidationErrors} from "@angular/forms";
import {UsernameCheckService} from "../services/username-check.service";
import {Observable} from "rxjs";
import {catchError, map} from "rxjs/operators";

@Directive({
  selector: '[appCheckValidUsername]',
  providers: [{provide:NG_ASYNC_VALIDATORS, useExisting:CheckValidUsernameDirective, multi:true}]
})
export class CheckValidUsernameDirective implements AsyncValidator {

  constructor(private usernameCheckService:UsernameCheckService) {}

  // validate(control:AbstractControl):ValidationErrors {
  //   return checkValidUsernameValidator(this.usernameCheckService)(control);
  // }

  validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    return checkValidUsernameValidator(this.usernameCheckService)(control);
  }

}

export function checkValidUsernameValidator(usernameCheckService:UsernameCheckService): AsyncValidatorFn {
  return (ctrl: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
    return usernameCheckService.checkUsername(ctrl.value).pipe(
      map(result => (result['number'] !== 0 ? { uniqueUsername: true } : null)),
      catchError(() => null)
    )
  };
}

// @Injectable(
//   {
//     providedIn:'root'
//   }
// )
// export class CheckValidUsernameValidator implements AsyncValidator {
//
//   constructor(private usernameCheckService:UsernameCheckService) {}
//
//   validate(ctrl:AbstractControl):Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
//     return this.usernameCheckService.checkUsername(ctrl.value).pipe(
//       map(result => (result['number'] !== 0 ? { uniqueUsername: false } : null)),
//       catchError(() => null)
//     )
//   }
//
// }
